export enum FeatureFlag {
    IS_CHAIN_AUTO_SUGGESTION_ENABLED = 'isChainAutoSuggestionEnabled',
    IS_COMMUNICATION_ENABLED = 'isCommunicationEnabled',
}

export const FEATURE_FLAG_DEFAULTS: Record<FeatureFlag, boolean> = {
    [FeatureFlag.IS_CHAIN_AUTO_SUGGESTION_ENABLED]: false,
    [FeatureFlag.IS_COMMUNICATION_ENABLED]: false,
};
